import { getInventoryFields } from "@/Motivators/api/specialUnits";
import { RootState } from "@/redux/store";
import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";

type InventoryFieldsMatchesArray = [
	{ property: string; value: string; operator: string },
	{ property: string; value: string; operator: string; type: string; dataType: string; regex: boolean }
];

interface InventoryField {
	values: string[];
	paths: string[];
	matches: InventoryFieldsMatchesArray;
}

export const useSpecialUnitsInventoryFields = (enabled = true) => {
	const locationId = useSelector((state: RootState) => state.location.location?.locationId);

	const { data = { fields: {}, resolvers: {}, keys: [] }, ...otherResults } = useQuery({
		queryKey: ["inventoryFields", locationId],
		queryFn: async () => {
			if (!locationId) {
				throw new Error("Location ID is not available");
			}
			const responseInventoryFields = await getInventoryFields(locationId);
			const fieldsInv = JSON.parse(responseInventoryFields?.values ?? "{}") as Record<string, InventoryField>;
			return {
				fields: Object.keys(fieldsInv).reduce(
					(acc, key) => ({
						...acc,
						[key]: {
							values: [...(fieldsInv[key]?.values ?? [])].sort((a, b) => a.localeCompare(b)),
							isNumber: !fieldsInv[key]?.matches[1].regex,
						},
					}),
					{} as Record<string, { values: string[]; isNumber: boolean }>
				),
				resolvers: Object.keys(fieldsInv).reduce(
					(acc, key) => ({ ...acc, [key]: { paths: fieldsInv[key]?.paths, matches: fieldsInv[key]?.matches } }),
					{} as Record<string, { paths: string[]; matches: InventoryFieldsMatchesArray }>
				),
				keys: Object.keys(fieldsInv).sort((a, b) => a.localeCompare(b)),
			};
		},
		staleTime: Infinity,
		enabled: enabled && !!locationId,
	});

	return { data, ...otherResults };
};
